/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-nocheck
// This file is autogenerated by scripts/build-registry.ts
// Do not edit this file directly.
import * as React from "react"

export const Index: Record<string, any> = {
  "index": {
    name: "index",
    description: "",
    type: "registry:style",
    registryDependencies: ["cn","theme","context","resolve-classname"],
    files: [],
    component: null,
    meta: undefined,
  },
  "cn": {
    name: "cn",
    description: "",
    type: "registry:lib",
    registryDependencies: undefined,
    files: [{
      path: "registry/lib/cn.ts",
      type: "registry:lib",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/lib/cn.ts")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "theme": {
    name: "theme",
    description: "",
    type: "registry:lib",
    registryDependencies: undefined,
    files: [{
      path: "registry/lib/theme.tsx",
      type: "registry:lib",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/lib/theme.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "context": {
    name: "context",
    description: "",
    type: "registry:lib",
    registryDependencies: undefined,
    files: [{
      path: "registry/lib/context.ts",
      type: "registry:lib",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/lib/context.ts")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "resolve-classname": {
    name: "resolve-classname",
    description: "",
    type: "registry:lib",
    registryDependencies: undefined,
    files: [{
      path: "registry/lib/resolve-classname.ts",
      type: "registry:lib",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/lib/resolve-classname.ts")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "button-context": {
    name: "button-context",
    description: "Context for button components",
    type: "registry:lib",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/buttons/context.ts",
      type: "registry:lib",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/buttons/context.ts")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "button-types": {
    name: "button-types",
    description: "Types for button components",
    type: "registry:lib",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/buttons/types.ts",
      type: "registry:lib",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/buttons/types.ts")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "base-button": {
    name: "base-button",
    description: "A button component",
    type: "registry:component",
    registryDependencies: ["button-context","button-types"],
    files: [{
      path: "registry/default/buttons/base.tsx",
      type: "registry:component",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/buttons/base.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "hover-expand-button": {
    name: "hover-expand-button",
    description: "A button component with hover expand",
    type: "registry:component",
    registryDependencies: ["base-button"],
    files: [{
      path: "registry/default/buttons/hover-expand-button.tsx",
      type: "registry:component",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/buttons/hover-expand-button.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "menu-a": {
    name: "menu-a",
    description: "A menu component",
    type: "registry:component",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/menus/menu-a.tsx",
      type: "registry:component",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/menus/menu-a.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "tabs-context": {
    name: "tabs-context",
    description: "Context for tabs components",
    type: "registry:lib",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/tabs/context.ts",
      type: "registry:lib",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/tabs/context.ts")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "base-tabs": {
    name: "base-tabs",
    description: "A tabs component",
    type: "registry:component",
    registryDependencies: ["tabs-context"],
    files: [{
      path: "registry/default/tabs/base.tsx",
      type: "registry:component",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/tabs/base.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "focus-tabs": {
    name: "focus-tabs",
    description: "A tabs component with focus",
    type: "registry:component",
    registryDependencies: ["base-tabs"],
    files: [{
      path: "registry/default/tabs/focus-tabs.tsx",
      type: "registry:component",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/tabs/focus-tabs.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "base-button-demo": {
    name: "base-button-demo",
    description: "",
    type: "registry:example",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/example/base-button-demo.tsx",
      type: "registry:example",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/example/base-button-demo.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "base-button-variants": {
    name: "base-button-variants",
    description: "",
    type: "registry:example",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/example/base-button-variants.tsx",
      type: "registry:example",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/example/base-button-variants.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "base-button-colors": {
    name: "base-button-colors",
    description: "",
    type: "registry:example",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/example/base-button-colors.tsx",
      type: "registry:example",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/example/base-button-colors.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "base-button-sizes": {
    name: "base-button-sizes",
    description: "",
    type: "registry:example",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/example/base-button-sizes.tsx",
      type: "registry:example",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/example/base-button-sizes.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "base-button-icons": {
    name: "base-button-icons",
    description: "",
    type: "registry:example",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/example/base-button-icons.tsx",
      type: "registry:example",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/example/base-button-icons.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "base-button-composition": {
    name: "base-button-composition",
    description: "",
    type: "registry:example",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/example/base-button-composition.tsx",
      type: "registry:example",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/example/base-button-composition.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "hover-expand-button-demo": {
    name: "hover-expand-button-demo",
    description: "",
    type: "registry:example",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/example/hover-expand-button-demo.tsx",
      type: "registry:example",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/example/hover-expand-button-demo.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "hover-expand-button-variants": {
    name: "hover-expand-button-variants",
    description: "",
    type: "registry:example",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/example/hover-expand-button-variants.tsx",
      type: "registry:example",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/example/hover-expand-button-variants.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "hover-expand-button-colors": {
    name: "hover-expand-button-colors",
    description: "",
    type: "registry:example",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/example/hover-expand-button-colors.tsx",
      type: "registry:example",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/example/hover-expand-button-colors.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "hover-expand-button-sizes": {
    name: "hover-expand-button-sizes",
    description: "",
    type: "registry:example",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/example/hover-expand-button-sizes.tsx",
      type: "registry:example",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/example/hover-expand-button-sizes.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "hover-expand-button-double-sided": {
    name: "hover-expand-button-double-sided",
    description: "",
    type: "registry:example",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/example/hover-expand-button-double-sided.tsx",
      type: "registry:example",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/example/hover-expand-button-double-sided.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "menu-a-demo": {
    name: "menu-a-demo",
    description: "",
    type: "registry:example",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/example/menu-a-demo.tsx",
      type: "registry:example",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/example/menu-a-demo.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
  "menu-a-colors": {
    name: "menu-a-colors",
    description: "",
    type: "registry:example",
    registryDependencies: undefined,
    files: [{
      path: "registry/default/example/menu-a-colors.tsx",
      type: "registry:example",
      target: ""
    }],
    component: React.lazy(async () => {
      const mod = await import("@/registry/default/example/menu-a-colors.tsx")
      const exportName = Object.keys(mod).find(key => typeof mod[key] === 'function' || typeof mod[key] === 'object') || item.name
      return { default: mod.default || mod[exportName] }
    }),
    meta: undefined,
  },
}